import { EntityView } from '@/common/entityFramework/entityView/EntityView';
import { TestDashboard } from './entities/testDashboard/TestDashboard';
import { Route } from 'react-router-dom';

const acRoutes = [
  <Route path="/ac/rqmt" element={<EntityView />} />,
  <Route path="/ac/section" element={<EntityView />} />,
  <Route path="/ac/suite" element={<EntityView />} />,
  <Route path="/ac/suite-test" element={<EntityView />} />,
  <Route path="/ac/test" element={<EntityView />} />,
  <Route path="/ac/test-run" element={<EntityView />} />,
  <Route path="/ac/dashboard/test" element={<TestDashboard />} />
]

export default acRoutes;
